import Icon from '../components/Icon.vue'

Icon.register({
  'person-booth': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M192 496C192 504.8 199.2 512 208 512H240C248.8 512 256 504.8 256 496V320H192V496zM224 224H173.1L127.9 178.7C115.8 166.6 99.7 160 82.7 160H64C46.9 160 30.8 166.7 18.7 178.8 6.7 190.9 0 207 0 224.1L0.2 320 0 480C0 497.7 14.3 512 31.9 512 49.5 512 63.9 497.7 63.9 480L64 379.3C64.9 379.8 65.6 380.6 66.5 381L95.6 424V480C95.6 497.7 109.9 512 127.6 512S159.6 497.7 159.6 480V423.5C159.6 413.6 157.3 403.7 152.9 394.9L111.7 333.6V253L132.6 273.9C141.7 283 153.7 288 166.5 288H224C241.7 288 256 273.7 256 256S241.7 224 224 224zM64 128C90.5 128 112 106.5 112 80S90.5 32 64 32 16 53.5 16 80 37.5 128 64 128zM288 32L319.5 255.1 288.6 409.7C284.3 431.3 301.6 448 320 448 335.2 448 348 438.9 352.3 417.6 353.2 434.5 366.9 448 384 448 401.7 448 416 433.7 416 416 416 433.7 430.3 448 448 448S480 433.7 480 416V0H288V32zM192 32V192H256V0H224C206.3 0 192 14.3 192 32zM544 0H512V496C512 504.8 519.2 512 528 512H560C568.8 512 576 504.8 576 496V32C576 14.3 561.7 0 544 0z'
      }
    ]
  }
})
